export default class SocialWidget {
  constructor () {
    this.init();
  }

  init() {
    const filterLinkedInFeeds = setInterval(() => {
      const tbButton = document.querySelector(".box-linkedin .taggbox .tb_filter_container .tb-linkedin");
      if (tbButton) {
        tbButton.click();
        clearInterval(filterLinkedInFeeds);
      }
    }, 1000);

    const filterFbFeeds = setInterval(() => {
      const tbButton = document.querySelector(".box-facebook .taggbox .tb_filter_container .tb-facebook");
      if (tbButton) {
        tbButton.click();
        clearInterval(filterFbFeeds);
      }
    }, 1000);

    const filterIgFeeds = setInterval(() => {
      const tbButton = document.querySelector(".box-instagram .taggbox .tb_filter_container .tb-instagram");
      if (tbButton) {
        tbButton.click();
        clearInterval(filterIgFeeds);
      }
    }, 1000);
  }
}
